export default {
  mobileLanding: {
    media: {
      appPreview: "Anteprima animata dell'app",
      leagues: "Schermata selezione leghe",
      trendFlow: "Flusso trend animato",
      trendAnalysis: "Schermata analisi trend dettagliata",
      myPicks: "Schermata Le mie scelte",
      checkout: "Schermata checkout",
    },
    sections: {
      research: {
        heading: "Dalla ricerca alla scommessa in pochi secondi",
        body: "Linemate fa la ricerca per te, analizzando trend e matchup così puoi passare dall'insight alla scommessa senza ore di ricerca.",
      },
      leagues: {
        body: "Scegli tra oltre 18 grandi leghe per esplorare trend e giocate su misura per le partite e i giocatori che ti interessano di più.",
      },
      trends: {
        body: "Sfoglia i trend migliori e scegli una giocata supportata da dati reali, rendimento recente e contesto rilevante.",
      },
      analysis: {
        body: "Approfondisci ogni giocata con analisi chiare su rendimento, contesto situazionale e segnali chiave che guidano il trend.",
      },
      odds: {
        body: "Trova le migliori quote disponibili tra gli operatori e ottieni il massimo valore da ogni scommessa.",
      },
      checkout: {
        body: "Completa in pochi secondi con il tuo betslip compilato automaticamente presso il tuo operatore preferito.",
      },
    },
    cta: {
      titleLineOne: "La tua casa",
      titleLineTwo: "per ogni scommessa",
    },
  },
};
